import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { Customerlogo } from '../model/customerlogo';

@Injectable({
  providedIn: 'root'
})
export class CustomerlogoService {

  constructor(private http:HttpClient) { }


  addCustomerLogoFile(file:File,url:string):Observable<any>{
    const httpOptionsUploade = {
      headers: new HttpHeaders({
        'Content-Type': file.type || 'application/octet-stream',
      }),
      withCredentials: true,
    }
    return this.http.put(url,file,httpOptionsUploade);
    
    
  }
  getSignedUploadUrl(filename:string, organizationId:string, customerId:string):Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const body = JSON.stringify({ Key: filename, kind: 'customer', organizationId, customerId });
    return this.http.post<any>(environment.apiUrl+'/logostore/getsignedurl',body,httpOptions);
  }


  deleteorgImage(){
    //TODO
  }
}
